import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 2 }

import { onMounted, ref, watch } from "vue";
import {
  ONBOARDING_SUMMARIZE_DURATION,
  ONBOARDING_SUMMARIZE_ERROR,
  ONBOARDING_SUMMARIZE_MESSAGE,
} from "@/util";
import {
  integrationsStore,
  onboardingApiStore,
  onboardingStore,
} from "@/hooks";
import {
  FlexBox,
  List,
  ListItem,
  Separator,
  TextButton,
  Typography,
} from "@/components/common";
import CalloutSubStep from "./CalloutSubStep.vue";
import JobLoadingSubStep from "./JobLoadingSubStep.vue";


/**
 * The onboarding step to import from GitHub, wait for the import, and display the generated summaries afterward.
 */
const __default__ = {
  name: "SummarizeStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const status = ref<"initial" | "loading" | "success" | "error">("initial");

/**
 * Sets the status to loading and starts a generation job when the user clicks the import button.
 */
function handleGenerate() {
  status.value = "loading";
  onboardingApiStore.handleImportAndSummarize();
}

/**
 * Updates the status when the job changes.
 */
function updateStatus(moveNext?: boolean) {
  const jobStatus = onboardingStore.uploadedJob?.status;

  if (!jobStatus) {
    status.value = "initial";
  } else if (jobStatus === "FAILED" || onboardingStore.error) {
    status.value = "error";
  } else if (jobStatus === "IN_PROGRESS") {
    status.value = "loading";
  } else if (status.value === "loading" && jobStatus === "COMPLETED") {
    status.value = "success";

    if (!moveNext) return;

    onboardingApiStore.handleLoadNextStep("summarize");
  }
}

onMounted(() => updateStatus());

watch(
  () => onboardingStore.error,
  (error) => {
    if (!error) return;
    updateStatus();
  }
);

watch(
  () => onboardingStore.uploadedJob,
  () => updateStatus(true)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Typography), {
      el: "div",
      value: _unref(ONBOARDING_SUMMARIZE_MESSAGE)
    }, null, 8, ["value"]),
    _createVNode(_unref(Typography), {
      el: "div",
      secondary: "",
      value: _unref(ONBOARDING_SUMMARIZE_DURATION)
    }, null, 8, ["value"]),
    (status.value === 'initial')
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          column: "",
          align: "center",
          t: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(List), { class: "full-width" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ListItem), {
                  color: "primary",
                  title: "Importing From GitHub",
                  subtitle: _unref(integrationsStore).gitHubFullProjectName,
                  icon: "project-add"
                }, null, 8, ["subtitle"]),
                _createVNode(_unref(Separator), { inset: "" }),
                _createVNode(_unref(ListItem), {
                  color: "primary",
                  title: "Generating Data",
                  subtitle: "Project Summary, File Summaries",
                  icon: "create-artifact"
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(FlexBox), { t: "4" }, {
              default: _withCtx(() => [
                _createVNode(_unref(TextButton), {
                  text: "",
                  color: "gradient",
                  class: "bd-gradient",
                  icon: "generate-artifacts",
                  disabled: _unref(onboardingStore).error,
                  onClick: handleGenerate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Import & Summarize ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(JobLoadingSubStep, { key: 1 }))
      : _createCommentVNode("", true),
    (status.value === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (status.value === 'error')
      ? (_openBlock(), _createBlock(CalloutSubStep, {
          key: 3,
          status: "error",
          message: _unref(ONBOARDING_SUMMARIZE_ERROR)
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})